/* eslint-disable max-len */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import {
  Typography,
  Skeleton,
  SkeletonBlock,
  Button
} from '@one-thd/sui-atomic-components';

const FlooringSkeleton = () => {
  return (
    <>
      <div className="accordion-card">
        <div
          className="sui-paper"
          style={{
            minHeight: '435px',
            paddingBottom: '2rem',
            borderTop: '0.1rem solid #f5f5f5'
          }}
        >
          <div className="card-header">
            <Typography variant="h2">Enter Rooms</Typography>
          </div>
          <div className="card-items">
            <div className="sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-text-primary">
              <div className="description-container">
                <p className="enter-rooms-description">
                  Enter the room information for your carpeting project. Add any
                  closets as individual rooms to ensure a more accurate
                  estimate. Don’t want to measure?{' '}
                  <a
                    href="https://www.homedepot.com/services/i/schedule-a-measure/b76e9e302/form?leadSource=cptconfig"
                    className="sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-text-primary focus-visible:sui-bg-focus focus-visible:sui-outline-none sui-underline"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {' '}
                    Schedule an in-home carpet measure
                  </a>{' '}
                  to get an estimate.
                </p>
                <div className="measuring-tipsLink-container">
                  <Typography decoration="underline" onClick={() => {}}>
                    Measuring Tips
                  </Typography>
                </div>
              </div>
              <div className="room-grid-title-wrapper">
                <div className="room-title-wrapper">
                  <Typography variant="h4">My Rooms</Typography>
                </div>
              </div>
              <div className="add-room-button-wrapper" />
              <div
                className="form-container"
                id="roomMeasures"
                data-testid="room-dimensions"
              />
              <hr className="horizontal-line" />
              <div className="stair-title-wrapper">
                <Typography variant="h4">Stairs</Typography>
              </div>
              <div className="add-stair-case-wrapper">
                <div className="add-step-button-wrapper" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flooring-card" style={{ display: 'none' }}>
        <div id="supersku-header">
          <Typography variant="h2" className="heading">
            Carpet
          </Typography>
          <Typography
            paragraph
            className="description"
            style={{ padding: '16px 0' }}
          >
            Your carpet selection has been carried over and applied to your
            estimate.
          </Typography>
          <Typography variant="h4" className="title">
            My Carpet
          </Typography>
        </div>
        <div className="supersku-container">
          <div className="supersku-img-container">
            <img
              className="supersku-img"
              alt="Default"
              height="320"
              width="320"
              style={{ display: 'block' }}
              src="https://images.thdstatic.com/productImages/66a37596-2188-4333-ab62-43cd45e123a6/svn/black-satin-home-decorators-collection-texture-carpet-hdd7980504-64_400.jpg"
            />
          </div>
          <div className="super-sku-details">
            <Typography paragraph>
              <SkeletonBlock height={6} width={36} />
            </Typography>
            <Typography variant="h4">
              <SkeletonBlock height={14} width={60} />
            </Typography>
          </div>
          <div className="super-sku-price">
            <p className="price">
              <SkeletonBlock height={11} width={20} />
            </p>
            <span className="unit">&nbsp;/sq. ft.</span>
          </div>
          <div className="super-sku-options">
            <div className="option-wrapper">
              <Typography paragraph style={{ marginBottom: '4px' }}>
                <SkeletonBlock height={11} width={60} />
              </Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {Array.from({ length: 30 }).map(() => (
                  <div className="swatch-override">
                    <div className="swatch-root" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { FlooringSkeleton };
